import { render, staticRenderFns } from "./examTopicIndexDialog.vue?vue&type=template&id=b6c7afd8&scoped=true"
import script from "./examTopicIndexDialog.vue?vue&type=script&lang=js"
export * from "./examTopicIndexDialog.vue?vue&type=script&lang=js"
import style0 from "./examTopicIndexDialog.vue?vue&type=style&index=0&id=b6c7afd8&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c7afd8",
  null
  
)

export default component.exports